import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "base-fixed-aside__item-icon" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "base-fixed-aside__item-chevron"
}

import { onMounted, ref, nextTick } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseFixedAsideElement',
  props: {
    icon: { default: 'messages-question' },
    lable: { default: 'Zu den FAQ' },
    link: {},
    linkTarget: {},
    color: {},
    background: {},
    content: {}
  },
  setup(__props: any) {



const contentEl = ref<HTMLElement>();
const cssVariables = ref<Record<string, string>>({});
const isMounted = ref(false);
const setCssVariables = () => {
  if (contentEl.value === undefined) return;

  contentEl.value?.style.setProperty('height', 'auto');

  const contentElHeight = contentEl.value?.offsetHeight;

  if (!contentElHeight) return;

  cssVariables.value['--content-height'] = `${contentElHeight}px`;

  contentEl.value?.style.removeProperty('height');
};

onMounted(() => {
  setCssVariables();
  nextTick(() => {
    isMounted.value = true;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_FaIcon = _resolveComponent("FaIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-fixed-aside__item", {
        'is-link': !!_ctx.link,
        'mounted': isMounted.value,
      }]),
    style: _normalizeStyle({
        background: _ctx.background,
        color: _ctx.color,
        ...cssVariables.value,
      })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_FaIcon, {
        icon: `fa-light fa-${_ctx.icon}`
      }, null, 8, ["icon"])
    ]),
    _createElementVNode("div", {
      ref_key: "contentEl",
      ref: contentEl,
      class: "base-fixed-aside__item-content",
      innerHTML: _ctx.content
    }, null, 8, _hoisted_2),
    (_ctx.link)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_FaIcon, { icon: "fa-light fa-chevron-right" })
        ]))
      : _createCommentVNode("", true),
    (_ctx.link)
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 1,
          to: _ctx.link,
          target: _ctx.linkTarget
        }, null, 8, ["to", "target"]))
      : _createCommentVNode("", true)
  ], 6))
}
}

})